// EcomNewCustomersCard.tsx
import { useEffect, useState } from 'react';
import { Card, Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { getOrderData, OrderData } from 'api/dashboard/_request';
import EcomNewCustomersChart from 'components/charts/e-charts/EcomNewCustomersChart';

type RangeType = 'today' | 'week' | 'month' | 'year';

const ranges: { label: string; value: RangeType }[] = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'This Year', value: 'year' }
];

const EcomNewCustomersCard = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [range, setRange] = useState<RangeType>('year');
  const [customerData, setCustomerData] = useState<OrderData[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await getOrderData({ range, id });
        setCustomerData(data || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [range]);

  return (
    <Card className="h-100">
      <Card.Body>
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
          <div>
            <h5 className="mb-1">Customers Spent</h5>
            <h6 className="text-body-tertiary">Last {range}</h6>
            <h4>{customerData.length}</h4>
          </div>
          <Col xs={12} sm={6} className="ps-0 ps-sm-3">
            <Form.Select
              size="sm"
              value={range}
              onChange={e => setRange(e.target.value as RangeType)}
            >
              {ranges.map(r => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </Form.Select>
          </Col>
        </div>
        <div className="pt-4">
          <EcomNewCustomersChart data={customerData} range={range} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default EcomNewCustomersCard;
